'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _App = require('./components/App.jsx');

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isIphone = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
var isIpad = navigator.userAgent.match(/iPad/i);
var isAndroid = navigator.userAgent.match(/Android/i);
var isMobile = isIphone || isIpad || isAndroid;
var isDesktop = !isMobile;

document.body.classList.add(isDesktop ? 'desktop' : 'mobile');

_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('container'));


//////////////////
// WEBPACK FOOTER
// ./client/index.js
// module id = 365
// module chunks = 0